// Whether a task group's details panel is open or folded to its action bar (S128), remembered
// per browser for every group, like the rail's width (layout/railWidth.ts).
import { useState } from "react";

const KEY = "ocs.group-panel";

function savedOpen(): boolean {
  try {
    return localStorage.getItem(KEY) !== "collapsed";
  } catch {
    // Storage can be blocked (private mode); start open.
    return true;
  }
}

export function useGroupPanelOpen(): [boolean, (open: boolean) => void] {
  const [open, setOpen] = useState(savedOpen);
  const choose = (next: boolean) => {
    setOpen(next);
    try {
      localStorage.setItem(KEY, next ? "expanded" : "collapsed");
    } catch {
      // Not persisting the choice is fine.
    }
  };
  return [open, choose];
}
